import {
  WS_GET_USER_DATA_FROM_FC_REQUEST,
  WS_GET_USER_DATA_FROM_FC_SUCCESS,
  WS_GET_USER_DATA_FROM_FC_FAILURE,
  CLEAR_FC_DATA,
} from '../actions';

export const initialState = {
  isFetching: false,
  error: '',
  user: null,
};

export const franceConnect = (state = initialState, action) => {
  switch (action.type) {
    case CLEAR_FC_DATA:
      return {
        isFetching: false,
        user: null,
        error: '',
      };
    case WS_GET_USER_DATA_FROM_FC_REQUEST:
      return {
        ...state,
        isFetching: true,
      };

    case WS_GET_USER_DATA_FROM_FC_SUCCESS:
      return {
        ...state,
        isFetching: false,
        user: action.payload,
      };
    case WS_GET_USER_DATA_FROM_FC_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: true,
        user: {},
      };

    default:
      return state;
  }
};
